import React from "react";

import {
  Card,
  CardBody,
  CardTitle,
  Container,
  Row,
  Col,
} from "reactstrap";

function ProjectsSolutions() {
  return (
    <div className="project-2 my-5 bg-default">
      <Container>
        <Row>
          <Col className="mx-auto text-center text-white my-5" lg="8">
            <h3 className="display-3 text-info">Case Studies: What we can do for you</h3>
            <p className="lead">
              The time is now for it to be okay to be great. People in this
              world shun people for being great.
            </p>
          </Col>
        </Row>
        <Row>
          <Col lg="4" md="6">
            <Card className="card-project">
              <p>
                <div className="icon icon-lg icon-shape icon-shape-info border border-info rounded-circle mx-auto">
                  <i className="ni ni-money-coins"></i>
                </div>
              </p>
              <CardBody>
                <CardTitle className="mt-3 text-info text-center" tag="h4">
                  Asset Tracing
                </CardTitle>
                <p className="card-description font-weight-normal">
                  A victim of a sophisticated cryptocurrency scam, lost over £1,500,000 to 
                  fraudsters. Our team conducted a thorough investigation, utilizing advanced 
                  forensic techniques and human intelligence to trace the stolen assets across 
                  multiple blockchain networks. By collaborating with lawyers, law enforcement 
                  and crypto exchanges, we successfully identified the fraudster&#8217;s 
                  accounts highlighting the effectiveness of combining human intelligence with 
                  expert crypto asset tracing to provide actionable intelligence and successful 
                  recovery outcomes.
                </p>
              </CardBody>
            </Card>
          </Col>
          <Col lg="4" md="6">
            <Card className="card-project">
              <p>
                <div className="icon icon-lg icon-shape icon-shape-info border border-info rounded-circle mx-auto">
                  <i className="ni ni-sound-wave"></i>
                </div>
              </p>
              <CardBody>
                <CardTitle className="mt-3 text-info text-center" tag="h4">
                  Asset Discovery
                </CardTitle>
                <p className="card-description font-weight-normal">
                  During a contentious divorce, X suspected their spouse was hiding significant 
                  crypto assets. Our team conducted a thorough investigation using advanced 
                  blockchain forensics and human intelligence to trace transactions and identify 
                  undisclosed crypto wallets. Collaborating closely with their legal team, we provided 
                  documented evidence that was instrumental in court. This led to a fairer division 
                  of assets and highlights the effectiveness of combining human intelligence with 
                  expert crypto asset tracing to ensure just outcomes in divorce proceedings
                </p>
              </CardBody>
            </Card>
          </Col>
          <Col lg="4" md="6">
            <Card className="card-project">
              <p>
                <div className="icon icon-lg icon-shape icon-shape-info border border-info rounded-circle mx-auto">
                  <i className="ni ni-archive-2"></i>
                </div>
              </p>
              <CardBody>
                <CardTitle className="mt-3 text-info text-center" tag="h4">
                  Due Diligence
                </CardTitle>
                <p className="card-description font-weight-normal">
                 A multinational corporation, sought to acquire a smaller tech company. Our team 
                 conducted a thorough due diligence investigation, including financial reviews, 
                 risk profiling, compliance audits, reputational analysis, and supply chain evaluation. 
                 Leveraging human intelligence, we uncovered hidden liabilities and operational 
                 inefficiencies, providing actionable insights. This enabled the corporation to 
                 negotiate better terms, saving millions and ensuring a secure investment. This case 
                 underscores the importance of thorough due diligence.
                </p>
              </CardBody>
            </Card>
          </Col>
        </Row>
        <br></br>
        <Row>
          <Col lg="4" md="6">
            <Card className="card-project">
              <p>
                <div className="icon icon-lg icon-shape icon-shape-info border border-info rounded-circle mx-auto">
                  <i className="ni ni-bullet-list-67"></i>
                </div>
              </p>
              <CardBody>
                <CardTitle className="mt-3 text-info text-center" tag="h4">
                  Expert Witness
                </CardTitle>
                <p className="card-description font-weight-normal">
                  In a money laundering case, CrypTegridy was engaged to trace complex crypto asset 
                  transactions and provide expert witness testimony. Our team conducted an in-depth 
                  blockchain analysis, leveraging human intelligence to identify nuanced patterns and 
                  connections. We prepared a detailed report outlining the traced transactions and 
                  connections to the suspect. Our expert witness presented these findings in court, 
                  explaining the blockchain tracing process and linking the suspect to illicit 
                  activities. The thoroughness and reliability of our analysis were crucial, 
                  demonstrating the importance of combining human intelligence with advanced blockchain 
                  analysis for actionable intelligence in legal cases.
                </p>
              </CardBody>
            </Card>
          </Col>
          <Col lg="4" md="6">
            <Card className="card-project">
              <p>
                <div className="icon icon-lg icon-shape icon-shape-info border border-info rounded-circle mx-auto">
                  <i className="ni ni-paper-diploma"></i>
                </div>
              </p>
              <CardBody>
                <CardTitle className="mt-3 text-info text-center" tag="h4">
                  Private Investigation
                </CardTitle>
                <p className="card-description font-weight-normal">
                 X suspected financial misconduct within their family. Our team conducted a thorough 
                 investigation, including discreet surveillance, digital footprinting, and background 
                 checks. We monitored relevant activities and analyzed online communications to gather 
                 evidence. Our discreet measures ensured the investigation remained 
                 confidential. This confirmed X&#8217;s suspicions, providing clear evidence of 
                 financial misconduct. The detailed report and evidence we provided were instrumental, 
                 helping X take appropriate legal action. It is importance of combining human 
                 intelligence with advanced investigative techniques 
                 to provide actionable intelligence and successful resolutions.
                </p>
              </CardBody>
            </Card>
          </Col>
          <Col lg="4" md="6">
            <Card className="card-project">
              <p>
                <div className="icon icon-lg icon-shape icon-shape-info border border-info rounded-circle mx-auto">
                  <i className="ni ni-world-2"></i>
                </div>
              </p>
              <CardBody>
                <CardTitle className="mt-3 text-info text-center" tag="h4">
                  Counterintelligence
                </CardTitle>
                <p className="card-description font-weight-normal">
                  A leading tech firm, suspected information leaks to competitors and engaged CrypTegridy 
                  for a counterintelligence investigation. Our team conducted discreet surveillance, digital 
                  footprinting, and forensic analysis, revealing that a mid-level employee was leaking 
                  information for financial incentives. The evidence led to the employee&#8217;s termination 
                  and legal action against the competitor. This case underscores the importance of thorough 
                  counterintelligence investigations in protecting corporate assets, with CrypTegridy 
                  providing the expertise needed for a successful resolution and enhanced security.
                </p>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default ProjectsSolutions;
